import { render, staticRenderFns } from "./OfferInvitationsCurrentTab.vue?vue&type=template&id=4d24ee84&"
import script from "./OfferInvitationsCurrentTab.vue?vue&type=script&lang=js&"
export * from "./OfferInvitationsCurrentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports